define('views/avatar_uploader/Podio.Views.AvatarUploader.Modal',['require','translate','underscore','jquery','lib/backbone/Backbone.PodioView','lib/Podio.UI.Modal','jst!avatar_uploader/_main','jst!avatar_uploader/_pending','jst!shared/_modal_ok_cancel_footer','lib/fileuploader/avatar','lib/Podio.UI.FlashMessage','lib/Podio.Router'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var Modal = require('lib/Podio.UI.Modal');
  var jstMain = require('jst!avatar_uploader/_main');
  var jstPending = require('jst!avatar_uploader/_pending');
  var jstModalFooter = require('jst!shared/_modal_ok_cancel_footer');
  var fileUploaderAvatar = require('lib/fileuploader/avatar');
  var FlashMessage = require('lib/Podio.UI.FlashMessage');
  var router = require('lib/Podio.Router');

  return ViewPodioBase.extend({
    podioEvents: {
      'click .facebook-uploader-trigger': 'onFacebookConnectClicked',
      'click .done-button': 'onDoneButtonClicked'
    },

    initialize: function() {
      _.bindAll(this, 'onAvatarUploaded', 'onAvatarRemoved');

      this._super();
    },

    _setElm: function() {
      this.el = $('.avatar-uploader-modal').get(0);
      this.setElement(this.el);
      this.elm = $(this.el);
    },

    showModal: function(content) {
      Modal.show(content, {
        title: t('Upload Profile Photo #avataruploader'),
        className: 'avatar-uploader-modal',
        footerHtml: this.getTemplate(jstModalFooter)
      });

      this._setElm();
      this.podioDelegateEvents();
    },

    initUploader: function() {
      var elmUploadImage = this.elm.find('.upload-attachment img');

      var uploader = fileUploaderAvatar.render(this.elm.find('.main-section'), {
        elmAvatarUpload: this.elm.find('.avatar-upload'),
        elmAvatarWrapper: this.elm.find('.upload-attachment'),
        elmUploadImage: elmUploadImage,
        currentAvatarUrl: elmUploadImage.attr('src'),
        elmContactAvatarInput: this.elm.find('#profile_picture_modal_avatar_id'),
        removeAttachmentPath: '.inner-content .upload-attachment .remove-attachment'
      });

      uploader.signals.onFileUploaded.add(this.onAvatarUploaded);
      fileUploaderAvatar.signals.onAvatarRemoved.add(this.onAvatarRemoved);
    },

    onAvatarUploaded: function() {
      var avatarId = this.elm.find('#profile_picture_modal_avatar_id').val();

      this.trigger('avatarUploaderView:avatarUploaded', avatarId);

      this.uploadTriggered = true;
      this.renderUploadCompleted();
      FlashMessage.show(t('Your profile picture has been uploaded #avataruploader'));
    },

    onAvatarRemoved: function() {
      // enable the SSO buttons again
      this.elm.find('.disabled').removeClass('disabled');

      this.trigger('avatarUploaderView:avatarRemoved');
    },

    renderRegular: function() {
      var markup = this.getTemplate(jstMain, {
        headline: t('Choose a photo #avataruploader'),
        content: t('Upload a photograph of your face from your computer, or let us get it from another service #avataruploader')
      });

      this.showModal(markup);
      this.initUploader();
    },

    renderInvite: function() {
      var markup = this.getTemplate(jstMain, {
        headline: t('You? #profile_picture_after_invite'),
        content: t('Did you know that people you invite are twice as likely to accept your invitation if they see your face in the e-mail? #profile_picture_after_invite'),
        notice: t('Your users were added! #avataruploader')
      });

      this.showModal(markup);
      this.initUploader();
    },

    renderUploadCompleted: function() {
      var heading = t('Much better #avataruploader');
      var content = t("We were right, it is an excellent smile. If you're not happy with the results try uploading a different one. #avataruploader");

      this.elm.find('.headline').text(heading);
      this.elm.find('.text-content').text(content);
    },

    renderUploadPending: function() {
      FlashMessage.show(t('Your profile photo will be updated shortly #avataruploader'));
      this.elm.find('.modal-content').html(this.getTemplate(jstPending));
    },

    showAvatar: function(link) {
      this.elm.find('.avatar-container .avatar').attr('src', link);
    },

    onFacebookConnectClicked: function(elmTarget, e) {
      if (elmTarget.hasClass('disabled')) {
        // stop propagation so data-tracking click handlers don't execute
        e.stopPropagation();
        return false;
      }

      this.uploadTriggered = true;
      this.trigger('avatarUploaderView:connectLinkedAccount', 'facebook');
    },

    onDoneButtonClicked: function(elmTarget, e) {
      if (this.uploadTriggered && !this.options.ignoreReload) {
        router.reloadCurrentPage();
      }
    }
  });

});

